<template lang="pug">
v-container(v-if="isLoading")
    v-row(align="center" v-for="index in 4" :key="index")
        v-col(cols="2" align="center").pr-0
            v-skeleton-loader(
                type="avatar"
            )
        v-col(cols="10" md="8")
            v-skeleton-loader(type="sentences")
v-container(v-else).suus__event-details
    v-row(align="center" v-if="eventStartDate")
        v-col(cols="2" align="center" ).pr-0
            v-icon(color="textColor" large) {{ calenderIcon }}
        v-col(cols="10")
            p.body-1
                b Datum:&nbsp;
                span {{formatToDateSpanLong(eventStartDate, eventEndDate)}}
                br
                span(v-if='eventStartTime')
                    b Start:
                    | {{ eventStartTime | formatTime }} &nbsp;
                span(v-if='eventEndTime && !eventEndTimeOpenEnd')
                    b Ende:
                    | {{ eventEndTime | formatTime}}
    v-row(align="center" v-if="location")
        v-col(cols="2" align="center").pr-0
            v-icon(color="textColor" large) {{ placeIcon }}
        v-col(cols="10").d-flex.justify-content
            p.body-1
                b Ort: &nbsp;
                | {{location }}
                br
                Hyperlink(text="In Google Maps öffnen", :url="location | googleMaps", targetBlank v-if="location")
    v-row(align="center" v-if="online")
        v-col(cols="2" align="center").pr-0
            OnlineEventIcon.pt-2
        v-col(cols="10")
            p.body-1
                Hyperlink(text="Link zur Online-Teilnahme" :url="eventCallUrl" targetBlank)
    v-row(align="center" v-if="eventContactName")
        v-col(cols="2" align="center").pr-0
            v-icon(color="textColor" large) {{ organiserIcon }}
        v-col(cols="10")
            p.body-1
                b Organisation: &nbsp;
                Hyperlink(:text='eventContactName', :url='eventContactUrl')
    v-row(align="center" v-if="eventCircleOfPartcipants")
        v-col(cols="2" align="center").pr-0
            v-icon(color="textColor" large) {{ accessIcon }}
        v-col(cols="10")
            p.body-1
                b Teilnehmerkreis: &nbsp;
                Hyperlink(:text="eventCircleOfPartcipantsName" :url="eventCircleOfPartcipantsUrl")
                | {{ this.eventData.allow_guests ? ' (mit Gästen)' : ''}}
                br
                b Sichtbarkeit:
                |&nbsp;{{eventAccess}}
</template>

<script lang="ts">
import Vue, { computed } from "vue"
import { createNamespacedHelpers } from "vuex"
const { mapState, mapGetters } = createNamespacedHelpers("event")
import { mdiCalendarRange } from "@mdi/js"
import { mdiMapMarkerOutline } from "@mdi/js"
import { mdiShieldAccountOutline } from "@mdi/js"
import { mdiAccountMultipleOutline } from "@mdi/js"
import OnlineEventIcon from "../icons/OnlineEventIcon.vue"
import Hyperlink from "../UI/Hyperlink.vue"
import { Event } from "suus-api"
import { useRSVPContext } from "app/modules/events/rsvp-context/use-rsvp-context.concern"
import store from "store"
import { DateUtil, formatToDateSpanLong } from "app/util/date.helper"

export default Vue.extend({
  name: "EventDetails",
  components: { OnlineEventIcon, Hyperlink },
  data() {
    return {
      calenderIcon: mdiCalendarRange,
      placeIcon: mdiMapMarkerOutline,
      organiserIcon: mdiShieldAccountOutline,
      accessIcon: mdiAccountMultipleOutline,
      dateSeparator: " - ",
    }
  },
  computed: {
    eventId() {
      return this.$route.params.event_id
    },
    eventCallUrl() {
      return this.eventData.custom_call_url
    },
    eventContactName() {
      return this.eventContact && this.eventContact.name
    },
    eventContactUrl() {
      return this.eventContact && this.eventContact.url
    },
    eventCircleOfPartcipantsName() {
      return this.eventCircleOfPartcipants && this.eventCircleOfPartcipants.name
    },
    eventCircleOfPartcipantsUrl() {
      return this.eventCircleOfPartcipants && this.eventCircleOfPartcipants.url
    },
    location() {
      return this.eventData && this.eventData.location
    },
    online() {
      return this.eventData && this.eventData.online
    },
    showEndDate() {
      if (
        this.eventData &&
        this.eventData.end_at &&
        this.eventData.end_at !== this.eventData.start_at
      ) {
        return true
      }
      return false
    },
    eventStartDate() {
      if (this.eventData && this.eventData.start_at) {
        return this.eventData.start_at
      }
      return null
    },
    eventEndDate() {
      if (this.showEndDate && this.eventData && this.eventData.end_at) {
        return this.eventData.end_at
      }
      return null
    },
    eventStartTime() {
      if (this.eventData && this.eventData.all_day) {
        return null
      } else if (this.eventData && this.eventData.start_at) {
        return this.eventData.start_at
      } else {
        return null
      }
    },
    eventEndTime() {
      if (this.eventData && this.eventData.all_day) {
        return null
      } else if (this.eventData && this.eventData.end_at) {
        return this.eventData.end_at
      } else {
        return null
      }
    },
    eventEndTimeOpenEnd() {
      console.log(this.eventData.end_at)
      if (!this.eventData) {
        return false
      }
      return (
        this.eventData.end_at &&
        DateUtil.getTimeString(new Date(this.eventData.end_at)).startsWith(
          "23:59"
        )
      )
    },
    eventAccess() {
      switch (this.eventData?.nonmember_access) {
        case "write":
          return "Offen"
        case "read":
          return "Intern"
        case "hidden":
          return "Geheim"
      }
    },
    ...mapState({
      eventData: (state: any): Event => state.currentEvent.data,
      eventError: (state: any): any => state.currentEvent.error,
    }),

    ...mapGetters(["eventContact", "eventCircleOfPartcipants"]),
  },
  setup() {
    const { loading } = useRSVPContext()
    const eventLoading = computed(() => store.getters["event/loading"])
    const isLoading = computed(() => loading.value || eventLoading.value)
    return { isLoading, formatToDateSpanLong }
  },
})
</script>

<style lang="sass" scoped>
$text-color: rgba(66, 66, 66, 1)
%font-stack
    font-family: system-ui !important
    color: $text-color
.suus__event-details
    p
        @extend %font-stack
        font-size: 16px
    b
        font-weight: 700
</style>
